import styled from 'styled-components';
import colors from 'constants/colors';

export const HistoryTable = styled.table`
  width: calc(100% + 30px);
  color: ${colors.white};
  border-bottom: 15px solid ${colors.black2};
  margin: 0 -15px 0 -15px;

  thead{
    th {
      color: ${colors.silver};
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 1px;
      padding: 5px 5px;
      background-color: ${colors.black2};
    }

    .arrival {
      width: 30%;
      padding-left: 15px;
    }
    .departure {
      width: 30%;
    }
    .roomType {
      width: 25%;
    }
    .details {
      width: 15%;
      padding-right: 15px;
    }
  }

  tbody{

    tr:nth-child(odd) {
      background-color: ${colors.black5};
    }
    tr:nth-child(even) {
      background-color: ${colors.black2};
    }
    
    td {
      color: ${colors.white};
      padding: 7px 5px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }

    td:first-child {
      padding-left: 15px;
    }

    td:last-child {
      text-align: right;
      padding-right: 15px;

      a {
        display: flex;
        color: ${colors.lightBlue};
        justify-content: center;
      }
    }
  }
`;

export const HistoryContainer = styled.div`
  width: 100%;
`;

export const NavigatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
`;

export const Navigator = styled.div`
  color: ${colors.lightBlue};
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;

  ${(props) => props.disabled ? `
    pointer-events:none;
    color: ${colors.dimGrey}
  `: null }
`;